/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import { ListPreferencesQueryVariables } from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const PreferenceCacheTypePolicies: TypePolicies = {
  Preference: {
    keyFields: ['key', 'targetId'],
  },
  Query: {
    fields: {
      listPreferences: {
        keyArgs: ['input', ['targetType', 'targetId', 'prefix']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListPreferencesQueryVariables>(
            existing,
            incoming,
            variables as ListPreferencesQueryVariables
          );
        },
      },
      getPreference(_, { args, toReference }) {
        return toReference({
          __typename: 'Preference',
          key: args?.input.key,
          targetId: args?.input.targetId,
        });
      },
    },
  },
};

export { PreferenceCacheTypePolicies };
